/* Action Items Store */

import {
    createActionItemType,
    fetchActionItemTypes,
    updateActionItemType,
    deleteActionItemType
} from '@/api'

const state = {}

const actions = {
    createActionItemType (context, payload) {
        return createActionItemType(payload)
    },
    fetchActionItemTypes (context, payload) {
        return fetchActionItemTypes(payload).then(r => {
            context.commit('setActionItemTypes', r.data)
        })
    },
    updateActionItemType (context, payload) {
        return updateActionItemType(payload)
    },
    deleteActionItemType (context, taskTypeId) {
        return deleteActionItemType(taskTypeId)
    }
}

const mutations = {
    setActionItemTypes (state, payload) {
        state.actionItemTypes = payload
    }
}

const getters = {
    getActionItemTypes (state) {
        return state.actionItemTypes
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}